const text = value => value == null || value === 'null' ? '' : String(value).trim();

export function addressString(address, includeContacts = true) {
    return [
        address.address_external_id ? '#' + address.address_external_id : '',
        address.name,
        address.ico,
        address.dic,
        includeContacts ? address.phone : null,
        includeContacts ? address.email : null,
        [text(address.street), text(address.house_number)].filter(Boolean).join(' '),
        address.suburb,
        address.city,
        address.postal_code,
        address.country,
        address.country_iso_code
    ].map(text).filter(Boolean).join(', ');
}

export function cartRecipient(address, previousRecipient) {
    return {
        address_id: address.address_external_id,
        buyer_id: address.external_buyer_id,
        address_string: addressString(address, false),
        email: previousRecipient ? previousRecipient.email : address.email,
        phone: previousRecipient ? previousRecipient.phone : address.phone
    };
}
